<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">TROTSKY</h1>
<p class="titlea">THE PASSIONATE REVOLUTIONARY</p>
<p class="author">ALLAN TODD</p>
<div class="image_container">
<img alt="images" src="images/f0iii-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?62c9e0ba